<template lang="pug">
  .field.datepicker
    flat-pickr( v-model="time_formatted" :config="options" :placeholder="placeholder")
    .prefix.date
      span.icon-calendar
</template>

<script>
import moment from "moment-timezone"
import flatPickr from 'vue-flatpickr-component';

export default {
  components:{flatPickr},
  computed: {
    time_formatted: {
      get(){
        return this.time_from_zone(this.value, 'YYYY-MM-DDTHH:mm')
      },
      set(val){
        // user_time - Time that users sees in UI
        if(val){
          const user_time = moment(val).zone(new Date(val).getTimezoneOffset()).format('YYYY-MM-DDTHH:mm:ss')
          val = moment.tz(user_time, window.time_zone).utc().format('YYYY-MM-DDTHH:mm:SSZ')
          this.$emit('input', val)
        }else {
          this.$emit('input', null)
        }

      }
    }
  },

  methods: {

  },
  props: [
    'options',
    'placeholder',
    'value'
  ],
  data(){
    return {

    }
  }
}

</script>
<style scoped>

</style>
